"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="min-h-screen bg-[#0b0b10] text-white">
      <div className="mx-auto flex min-h-screen w-full max-w-[720px] flex-col items-start justify-center px-6 py-16">
        <p className="text-xs uppercase tracking-[0.35em] text-white/50">
          Something went wrong
        </p>
        <h1 className="mt-3 text-3xl font-heading">We hit a snag.</h1>
        <p className="mt-3 text-sm text-white/60">
          Try again, or refresh the page if the issue persists.
        </p>
        <button
          onClick={reset}
          className="mt-6 rounded-full bg-[var(--hopp-gold)] px-6 py-3 text-xs font-bold uppercase tracking-[0.35em] text-[#f5f2ea]"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
